import css from '../../../utils/css';

export default css`
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
    src: url(https://betfanatics.com/_next/static/media/e4af272ccee01ff0-s.p.woff2)
      format('woff2');
  }

  :host,
  #root > div {
    --fanatics-card-bg: #17181c;
    --fanatics-panel-bg: #26272c;
    --fanatics-button-bg: #303137;
    --fanatics-button-bg-hover: #3a3b41;
    --fanatics-divider: #2e2f34;
    --fanatics-red: #e53c2e;
    --fanatics-white: #ffffff;
    --fanatics-muted: #9a9aa1;
    --fanatics-grey: #474747;

    --widget-font-family: 'Inter', sans-serif;

    --widget-background-color: var(--fanatics-card-bg);
    --widget-text-color: var(--fanatics-white);
    --widget-accent-background-color: var(--fanatics-panel-bg);
    --widget-accent-text-color: var(--fanatics-white);
    --widget-divider-color: var(--fanatics-divider);

    --widget-cta-color: var(--fanatics-white);
    --widget-cta-background-color: var(--fanatics-white);
    --widget-cta-text-color: var(--fanatics-white);
    --widget-cta-border-color: var(--fanatics-red);

    --widget-cta-primary-color: var(--fanatics-red);
    --widget-cta-primary-color-contrast: var(--fanatics-white);

    --widget-form-selected-background-color: var(--fanatics-red);
    --widget-form-selected-border-color: var(--fanatics-red);
    --widget-child-background-color: var(--fanatics-panel-bg);
    --widget-child-text-color: var(--fanatics-white);

    --widget-modal-background-color: var(--fanatics-card-bg);
    --widget-modal-background-color-contrast: var(--fanatics-white);

    --widget-modal-border-radius-custom: 12px;
    --widget-modal-buttons-border-radius-custom: 24px;

    --widget-cta-color-inverse: var(--fanatics-white);

    --widget-brand-logo: none;

    --widget-body-background-color: var(--fanatics-grey);

    /* Button theming for fanatics */
    --widget-button-border-radius: 8px;
    --widget-button-height: 45;
    --widget-button-background: var(--fanatics-button-bg);
    --widget-button-background-hover: var(--fanatics-button-bg-hover);
    --widget-button-selected-background: var(--fanatics-red);
    --widget-button-selected-text: var(--fanatics-white);
    --widget-button-border: none;
  }
`;
